import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const BIBLE_VERSIONS: Record<string, string> = { kjv: "KJV", web: "WEB", asv: "ASV", bbe: "BBE", ylt: "YLT" };
const GATEWAY: Record<string, string> = { kjv: "KJV", web: "WEB", asv: "ASV", ylt: "YLT", bbe: "KJV" };

export function useBibleVersion() {
  const { user } = useAuth();
  const id = user?.bible_version && BIBLE_VERSIONS[user.bible_version] ? user.bible_version : "kjv";
  return { id, abbr: BIBLE_VERSIONS[id] };
}

export const passageUrl = (ref: string, id = "kjv") => `https://www.biblegateway.com/passage/?search=${encodeURIComponent(ref)}&version=${GATEWAY[id] || "KJV"}`;

// Returns a KJV quote rendered in the reader's chosen version
export function useVerse(ref: string, kjv: string) {
  const { id, abbr } = useBibleVersion();
  const [text, setText] = useState(kjv);
  useEffect(() => {
    setText(kjv);
    if (id === "kjv") return;
    let live = true;
    api.get("/bible/verse", { params: { ref, kjv } }).then((r) => live && setText(r.data.text)).catch(() => {});
    return () => { live = false; };
  }, [ref, kjv, id]);
  return { text, abbr };
}
